import { Disclosure } from "@headlessui/react";

export const DropDownMenuPanel = (props: React.PropsWithChildren) => {
  return (
    <Disclosure.Panel className="flex flex-col gap-y-6 pl-3 mt-6">
      {props.children}
    </Disclosure.Panel>
  );
};
